export default {
  es: {
    continuar: 'Continuar',
    verResultados: 'Ver resultados',
    cambiarRespuestas : 'Cambiar respuestas',
    finalizar: 'Finalizar',
    home1: 'Bienvenido al cuestionario sobre la catarata',
    home2: 'Selecciona el idioma y pulsa continuar',
    questions: {
      1: 'La catarata forma parte del proceso natural de envejecimiento de las personas',
      2: 'Hay que dejar que la catarata se desarrolle del todo antes de buscar tratamiento',
      3: '¿Cuáles de las siguientes opciones son viables para tratar las cataratas?',
      4: 'Durante la operación de cataratas también sería posible corregir otras afecciones visuales como el astigmatismo y la vista cansada',
      5: 'Basándote en lo que sabes, ¿cuáles de los siguientes síntomas podrían ser de cataratas?'
    },
    answers: {
      1: {
        a: 'Sí',
        b: 'No'
      },
      2: {
        a: 'Sí, es correcto',
        b: 'No, no es correcto'
      },
      3: {
        a: 'Gotas oftálmicas',
        b: 'Vitaminas',
        c: 'Cambiar de gafas',
        d: 'La cirugía es la única opción'
      },
      4: {
        a: 'Sí, es correcto',
        b: 'No, no es correcto'
      },
      5: {
        a: 'Visión borrosa',
        b: 'Halos alrededor de las luces',
        c: 'Visión degradada de los colores',
        d: 'Dificultad para ver de noche',
        e: 'Picor en los ojos',
        f: 'Dolor de ojos',
        g: 'Cambio de color de ojos'
      }
    }
  },
  ca: {
    continuar: 'Continuar',
    verResultados: 'Veure resultats',
    cambiarRespuestas : 'Canviar respostes',
    finalizar: 'Finalitzar',
    home1: 'Selecciona l\'idioma i prem continuar',
    home2: 'Benvingut al qüestionari sobre la cataracta',
    questions: {
      1: 'La cataracta forma part del procés natural d’envelliment de les persones',
      2: 'Cal deixar que la cataracta es desenvolupi del tot abans de buscar tractament? ',
      3: 'Quines de les següents opcions són viables per tractar les cataractes?',
      4: 'Durant l’operació de cataractes també seria possible corregir altres afeccions visuals com l’astigmatisme i la vista cansada. ',
      5: 'Basant-te en el que saps, quin dels següents símptomes podrien ser de cataractes?'
    },
    answers: {
      1: {
        a: 'Sí',
        b: 'No'
      },
      2: {
        a: 'Sí, és correcte',
        b: 'No, no es correcte'
      },
      3: {
        a: 'Gotes oftàlmiques',
        b: 'Vitamines',
        c: 'Canviar d’ulleres / lents de contacte',
        d: 'La cirurgia és l’única opció'
      },
      4: {
        a: 'Sí, és correcte',
        b: 'No, no es correcte'
      },
      5: {
        a: 'Visió borrosa',
        b: 'Halos al voltant de les llums',
        c: 'Visió degradada dels colors',
        d: 'Dificultat per veure de nit',
        e: 'Picor als ulls',
        f: 'Dolor d’ulls',
        g: 'Canvi de color d’ulls'
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/messages.js